import { adminHttpClient } from "../../../commons/adminHttpClinet";
import { UpdateSubscription } from "../../../models/dashboard/subscriptions/subscriptions";

const updateSubscriptionPlan = (model: UpdateSubscription) => {
     return adminHttpClient.put("/api/Admin/AdminSubscriptions/update-subscription-plan", model);
};
export  default updateSubscriptionPlan;